import { gql } from "apollo-angular";
import { CBFF } from "./content-block-full";
import { DIF } from "./disclaimer-item";

export const HTF = gql`
fragment HTF on HorizontalTabs {
  backgroundColor {
    color
  }
  header
  headerTag
  hTagId
  title
  content
  tabbedContentCollection (limit:6) {
    items {
      ...on ContentBlock {
        ...CBFF
      }
      ...on HorizontalTabContent {
        title
        primaryContent {
          ...CBFF
        }
        secondaryContent {
          ...CBFF
        }
      }
    }
  }
  disclaimer{
    ...DIF
  }
}
${CBFF}
${DIF}`;
